import React from "react";
import "./TrustedPartner.css";
import { FaMoneyBillWave, FaMapMarkedAlt, FaUserTie } from "react-icons/fa";

const TrustedPartner = () => {
  return (
    <section className="trusted-container">
      <div className="trusted-top">
        <h2 className="trusted-heading">
          TRUSTED TRAVEL <br /> PARTNER
        </h2>

        <p className="trusted-description">
          With years of experience, a wide range of vehicles, and 24/7 customer
          support, our goal is to make every journey safe, smooth, and memorable.
          Discover top destinations with us and travel with complete peace of mind.
        </p>
      </div>

      <div className="trusted-features">
        <div className="feature-box">
          <div className="icon-box">
            <FaMoneyBillWave />
          </div>
          <h4>AFFORDABLE PRICE</h4>
          <p>
            We offer competitive and transparent pricing tailored to suit every
            budget. Sanavi Travels ensures value-for-money without compromising
            on comfort or service quality.
          </p>
        </div>

        <div className="feature-box">
          <div className="icon-box">
            <FaMapMarkedAlt />
          </div>
          <h4>BEST DESTINATION</h4>
          <p>
            Explore handpicked destinations like Mahabaleshwar, Shirdi, Goa,
            Lonavala, and more with carefully curated routes and experiences.
          </p>
        </div>

        <div className="feature-box">
          <div className="icon-box">
            <FaUserTie />
          </div>
          <h4>PERSONAL SERVICE</h4>
          <p>
            From your first inquiry to your final drop-off, we provide
            personalized attention and dedicated support for a smooth journey.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TrustedPartner;
